import utils from '../../../utils/utils.js';
export default {
    async fetchWaitingApproveFeeds(context, payload) {
        const bodyRequest = {
            approveStatus : payload.approveStatus,
            pageNumber : payload.pageNumber,
            pageSize : payload.pageSize,
            startDate: payload.startDate,
            endDate: payload.endDate
        };
        const params = utils.utility.checkQueryParams(bodyRequest);
        
        const response = await utils.utility.fetch(
            `api/Editor/GetWaitingApproveFeeds?${params.toString()}`,
            "GET",
            null,
            null
        )

        context.commit('setApproveList', response.data);

    },

    async fetchWaitingFeedAnswers(context, payload) {

        const response = await utils.utility.fetch(
            `api/Editor/GetWaitingFeedAnswers?feedId=${payload.feedId}`,
            "GET",
            null,
            null
        )
        context.commit('setWaitingFeedAnswers', response.data);
    },
    
    async fetchDisasterCrisisIsApproved(context) {
        const response = await utils.utility.fetch(
            `api/Editor/GetWorkspaceIsApproved`,
            "GET",
            null,
            null
        );
        context.commit("setDisasterCrisisIsApproved", response.data);
    },
    async sendReplyToApproveProcess(context, payload){
        const bodyRequest = {
            feedId : payload.feedId,
            answerType : payload.answerType,
            answer : payload.answer,
            accountId : payload.accountId,
            approveStatus: payload.approveStatus,
            clientDomain : payload.clientDomain,
            answerAttachMediaId : payload.answerAttachMediaId,
            feedAnswerId : payload.feedAnswerId,
            checkAnswer : payload.checkAnswer,
            accountName: payload.accountName
        };
        const response = await utils.utility.fetch(
            `api/Editor/SendAnswerApprove`,
            "POST",
            null,
            bodyRequest
        )
        if (response.data) {
            if (response.data.rules)
                context.commit("setCheckAnswerRules", response.data.rules);
            else
                context.commit("setCheckAnswerRules", null);
            context.commit("setIsSent", response.data.isSent);

        }
        else
            context.commit("setCheckAnswerRules", null);

    },
    async sendApproveReply(context, payload){
        const bodyRequest = {
            feedId : payload.feedId,
            answerType : payload.answerType,
            answer : payload.answer,
            accountId : payload.accountId,
            approveStatus: payload.approveStatus,
            answerAttachMediaId : payload.answerAttachMediaId,
            feedAnswerId : payload.feedAnswerId,
            accountName: payload.accountName
        };
        const response =  await utils.utility.fetch(
            `api/Editor/SendApproveReply`,
            "POST",
            null,
            bodyRequest
        )
        context.commit("setApproveReplyResponse", response.data);

    }
};